import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as Api from '../api';
import * as Types from '../types';

const useMarkRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: Types.IApi.MarkRead.Request) => {
      const res = await Api.MarkRead(data);
      return res.data;
    },
    onSuccess: () => {
      // Both list and badge are derived from the read state.
      queryClient.invalidateQueries({ queryKey: ['notifications', 'list'] });
      queryClient.invalidateQueries({ queryKey: ['notifications', 'unread-count'] });
    },
  });
};

export default useMarkRead;
